<template>
  <div class="page-exports">
    <landing-header />

    <main>
      <section class="hero-exports">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-data">Gestion de la Donnée</span>
            <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
              Vos données, <br />
              <span class="gradient-text">en toute liberté</span>
            </h1>
            <p class="text-xl text-gray-600 mb-8 leading-relaxed">
              Ne perdez plus de temps à retraiter des fichiers complexes. Exportez vos interventions, vos stocks et vos registres de fluides en un clic.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="/contact"><button class="btn-primary-large">Demander une démonstration</button></a>
              <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
            </div>
          </div>
          
          <div class="lg:w-1/2 w-full">
            <div class="export-ui-mockup shadow-2xl">
              <div class="export-header">
                <i class="fa-solid fa-file-export"></i> Paramètres d'export
              </div>
              <div class="export-body">
                <div class="filter-group">
                  <div class="filter-label">Type de donnée</div>
                  <div class="filter-select">Registre des Fluides</div>
                </div>
                <div class="filter-group">
                  <div class="filter-label">Période</div>
                  <div class="filter-select">Année 2025</div>
                </div>
                <button class="btn-export-visual">Générer le fichier .csv</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="text-center mb-16">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">Des exports structurés par métier</h2>
            <p class="text-gray-600">Extractions intelligentes adaptées aux besoins du CVC et de la maintenance.</p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div class="export-type-card">
              <div class="icon-wrap"><i class="fa-solid fa-boxes-stacked"></i></div>
              <h4>Stocks & Inventaires</h4>
              <p>États des stocks camions et entrepôts. Idéal pour vos inventaires de fin d'année et vos réapprovisionnements.</p>
            </div>
            <div class="export-type-card">
              <div class="icon-wrap"><i class="fa-solid fa-droplet"></i></div>
              <h4>Gaz & Fluides</h4>
              <p>Mouvements des bouteilles et quantités manipulées. Vos preuves réglementaires prêtes en 2 secondes.</p>
            </div>
            <div class="export-type-card">
              <div class="icon-wrap"><i class="fa-solid fa-screwdriver-wrench"></i></div>
              <h4>Activités Terrain</h4>
              <p>Détail des interventions par technicien, client ou site. Analysez votre productivité sans effort.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-900 text-white overflow-hidden relative">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <h2 class="text-3xl font-bold mb-6">Filtrez, ciblez, exportez</h2>
            <p class="text-gray-400 mb-8 text-lg">Ne vous noyez plus dans la masse de données. Utilisez nos filtres avancés pour n'extraire que l'essentiel :</p>
            <ul class="filter-list">
              <li><i class="fa-solid fa-filter"></i> Par technicien ou équipe</li>
              <li><i class="fa-solid fa-filter"></i> Par type d'équipement ou de contrat</li>
              <li><i class="fa-solid fa-filter"></i> Par statut d'intervention ou période précise</li>
            </ul>
          </div>
          <div class="lg:w-1/2 relative">
            <div class="data-grid-visual">
              <div class="grid-row header"><span>Date</span><span>Client</span><span>Fluide</span></div>
              <div class="grid-row"><span>12/01</span><span>Immo-X</span><span>R32</span></div>
              <div class="grid-row"><span>13/01</span><span>Syndic-Y</span><span>R410A</span></div>
              <div class="overlay-gradient"></div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div class="benefit-data">
              <span class="val">100%</span>
              <p>Données exploitables</p>
            </div>
            <div class="benefit-data">
              <span class="val">Zero</span>
              <p>Retraitement manuel</p>
            </div>
            <div class="benefit-data">
              <span class="val">Zen</span>
              <p>Face aux audits</p>
            </div>
            <div class="benefit-data">
              <span class="val">Pro</span>
              <p>Reporting clair</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-20 text-center bg-white">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black text-gray-900 mb-8">Maîtrisez enfin vos données d'entreprise</h2>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
             <a href="/contact"><button class="btn-primary-large">Demander une démonstration</button></a>
             <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
          </div>
        </div>
      </section>

      <landing-roi />
      <landing-avis />
    </main>

    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'

export default {
  name: 'ExportsPage',
  components: {
    LandingHeader,
    LandingFooter,
    LandingAvis,
    'landing-roi': LandingROI
  }
}
</script>

<style scoped>
/* --- UTILS --- */
.gradient-text {
  background: linear-gradient(to right, #f97316, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- HERO --- */
.hero-exports {
  padding: 10rem 0 6rem;
  background: radial-gradient(circle at top right, #fff7ed, transparent 35%);
}

.badge-data {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #f3f4f6;
  color: #374151;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  border: 1px solid #e5e7eb;
}

/* --- UI MOCKUP --- */
.export-ui-mockup {
  background: white;
  border-radius: 2rem;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}
.export-header { background: #f9fafb; padding: 1.5rem; font-weight: 800; border-bottom: 1px solid #e5e7eb; display: flex; align-items: center; gap: 0.75rem; color: #1f2937; }
.export-body { padding: 2rem; }
.filter-group { margin-bottom: 1.5rem; }
.filter-label { font-size: 0.7rem; font-weight: 800; text-transform: uppercase; color: #9ca3af; margin-bottom: 0.5rem; }
.filter-select { background: #f3f4f6; padding: 0.8rem 1rem; border-radius: 0.5rem; font-weight: 700; color: #1f2937; font-size: 0.9rem; }
.btn-export-visual { width: 100%; background: #16a34a; color: white; padding: 1rem; border-radius: 0.5rem; font-weight: 800; border: none; margin-top: 1rem; }

/* --- CARDS --- */
.export-type-card { background: #f9fafb; padding: 3rem 2rem; border-radius: 2rem; border: 1px solid #f3f4f6; transition: all 0.3s ease; }
.export-type-card:hover { border-color: #f97316; background: white; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.05); }
.icon-wrap { width: 3.5rem; height: 3.5rem; background: #fff7ed; color: #f97316; border-radius: 1rem; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; margin-bottom: 1.5rem; }
.export-type-card h4 { font-weight: 900; font-size: 1.25rem; margin-bottom: 1rem; }
.export-type-card p { color: #6b7280; font-size: 0.9rem; line-height: 1.6; }

/* --- DARK SECTION --- */
.filter-list { list-style: none; padding: 0; }
.filter-list li { display: flex; align-items: center; gap: 1rem; font-weight: 700; margin-bottom: 1.2rem; color: #d1d5db; }
.filter-list li i { color: #f97316; }

.data-grid-visual { background: #1f2937; border-radius: 1rem; overflow: hidden; border: 1px solid #374151; }
.grid-row { display: grid; grid-template-columns: 1fr 1.5fr 1fr; padding: 1rem; border-bottom: 1px solid #374151; font-size: 0.8rem; font-weight: 600; }
.grid-row.header { background: #111827; color: #9ca3af; font-weight: 800; text-transform: uppercase; }
.overlay-gradient { position: absolute; bottom: 0; left: 0; right: 0; height: 100px; background: linear-gradient(transparent, #111827); }

/* --- BENEFIT DATA --- */
.benefit-data { text-align: center; }
.benefit-data .val { display: block; font-size: 2.5rem; font-weight: 900; color: #f97316; margin-bottom: 0.5rem; }
.benefit-data p { font-weight: 800; color: #4b5563; font-size: 0.85rem; text-transform: uppercase; }

/* --- BUTTONS --- */
.btn-primary-large { background: #f97316; color: white; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; border: none; font-size: 1.1rem; }
.btn-outline-large { border: 2px solid #e5e7eb; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: #1f2937; text-decoration: none; display: inline-block; }

@media (max-width: 1024px) {
  .hero-exports { text-align: center; padding-top: 8rem; }
  .hero-exports .flex { flex-direction: column; }
  .export-ui-mockup { margin-top: 4rem; }
}
</style>